/**
 * Internal dependencies
 */
import WMUBlockArchive from "./block-archive";
import ViewportManager from "./viewport-manager";

/**
 * 
 */
class BlockArchiveManager {

	/**
	 * 
	 */
	constructor()
	{
		this.init();

		this.archiveList = [];
		this.archiveSelector = '.wmu-block.block-archive';
	}

	/**
	 * 
	 */
	init()
	{
		this.onViewportChange = this.onViewportChange.bind( this );
		document.addEventListener( 'WMUViewportChange', this.onViewportChange );
	}

	/**
	 * 
	 */
	clear()
	{
		const removeList = [];

		this.archiveList.forEach( ( archive ) =>
		{
			if ( -1 === archive.viewports.indexOf( ViewportManager.viewportCurrent ) )
			{
				removeList.push( archive );
			}
		} );

		removeList.forEach( ( archive ) =>
		{
			archive.clear();
			archive.element.wmuBlockArchive = null;
			this.archiveList.splice( this.archiveList.indexOf( archive ), 1 );
		} );
	}

	/**
	 * 
	 */
	setup()
	{
		/**
		 * 
		 */
		const elements = document.querySelectorAll( this.archiveSelector );

		elements.forEach( ( element ) =>
		{
			if ( element.wmuBlockArchive )
			{
				return;
			}

			let queryAttribute = element.getAttribute( 'query' );
			queryAttribute = ( queryAttribute ) ? JSON.parse( queryAttribute ) : null;
			
			if ( null === queryAttribute )
			{
				return;
			}

			queryAttribute = queryAttribute.find( ( value ) => value.viewports.indexOf( ViewportManager.viewportCurrent ) !== -1 );
			
			if ( ! queryAttribute )
			{
				return;
			}

			const blockArchive = new WMUBlockArchive( element, {
				url: wmuwpb.ajaxUrl,
				nonce: wmuwpb.blockArchive.nonce,
				action: wmuwpb.blockArchive.action,
				filterInputSelector: '.block-archive-filter-input',
				filterResetSelector: '.reset-filters',
				filtersFormSelector: '.block-archive-filters-form',
				highlightsWrapperSelector: '.block-archive-highlights',
				itempWrapperSelector: '.block-archive-items',
				viewports: queryAttribute.viewports,
				queryArgs: queryAttribute.query_args,
				highlights: queryAttribute.highlights,
				requestArgs: {
					from: 'wmublocks/archive',
					highlights: queryAttribute.highlights,
				}
			} );

			this.archiveList.push( blockArchive );
			element.wmuBlockArchive = blockArchive;
		} );
	}

	/**
	 * 
	 * @param {*} event 
	 */
	onViewportChange( event )
	{
		this.clear();
		this.setup();
	}

}

export default BlockArchiveManager;